module.exports = __webpack_public_path__ + "static/img/bg.847d426.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/result/images/bg.jpg
// module id = WDN3
// module chunks = 1